<template>
  <div class="books">
    <div v-show="showTitle" class="title row">
      <i></i>
      <span class="flex cc">{{title}}</span>
      <a v-if="showMore" class="cc more" @click="showMoreAction">更多</a>
<!--      <i v-if="showMore" class="iconfont icon-angle-right"></i>-->
    </div>
    <ul v-if="books && books.length > 0" class="booklist col-2">
      <li v-for="(item, index) in books" :key="index">
        <a class="cc" @click="toBookDetail(item.bookId)">
          <div class="pic">
            <img :bookid="item.bookId" :booktitle="item.title" :chapternum="0" :imgpath="item.horiCover" :zoom="1000" v-lazy="require('../../assets/images/loading_ho.jpg')" :alt="item.title"/>
            <span v-if="item.showPop" :class="['book-pop', item.popClass]">{{item.popText}}</span>
            <span :class="['book-tag', {'tag-red': item.publishStatus !== 'finish', 'tag-green': item.publishStatus === 'finish'}]">{{getPublishStatusText(item.publishStatus)}}</span>
          </div>
          <span>{{item.title}}</span>
          <p class="book-info">{{item.abstractContent}}</p>
        </a>
      </li>
    </ul>
    <div v-else class="h400">
      <div class="no_book">
        <p>暂时没有记录</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {getImg} from "../../services/urlService";
  import {getImgPlaceholder} from "../../services/urlService";

  export default {
    name: "books-middle",
    props: {
      title: String,
      books: Array,
      showTitle: {
        type: Boolean,
        default: true
      },
      showMore: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {}
    },
    methods: {
      toBookDetail(id) {
        this.$router.isBack = false;
        this.$router.push(`/book/${id}`)
      },
      showMoreAction() {
        this.$emit('show-more');
      },
      getPublishStatusText(code) {
        if (code === 'finish') {
          return '完结'
        } else {
          return '连载'
        }
      }
    },
    watch: {
      books(data) {
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/share/books-middle.vue